import { i18n } from './i18n';
i18n.resetLocales();
//# sourceMappingURL=load_default_locale_settings.js.map